export const convertNumberToPx = (num: number | string | undefined) => {
  if (!num) {
    return;
  }

  if (typeof num === "number") return `${num}px`;
  return num;
};
